import axios from 'axios'

export const getWeather = (latitude: string, longitude: string) =>
  axios.get(`https://api.open-meteo.com/v1/forecast?latitude=${parseInt(latitude)}&longitude=${parseInt(longitude)}&current_weather=true&hourly=temperature_2m,relativehumidity_2m,windspeed_10m&temperature_unit=fahrenheit`)


export const getLocationInfo = (latitude: string, longitude: string, apiKey: string) =>
  axios.get(`https://geocode.maps.co/reverse?lat=${parseFloat(latitude)}&lon=${parseFloat(longitude)}&api_key=${apiKey}`)
